import { observer } from "mobx-react-lite";
import classes from "./classes.module.scss";
import { useNavigationController } from "./hooks/useNavigationController";
import { FolderButtons } from "./components/FolderButtons";
import { OfficeMenu } from "./components/OfficeMenu";
import { SuperAdminMenu } from "./components/SuperAdminMenu";

const Navigation = observer(() => {
	const { officeMenuCandidates, permissionContext, loadingPermissions } = useNavigationController();

	return (
		<div className={classes["root"]}>
			<FolderButtons />
			{/* Menus "Espace office" et "Espace super admin" en dehors de Rules car ils ne dépendent pas de la règle "read officeFolders" */}
			<OfficeMenu officeMenuCandidates={officeMenuCandidates} />
			<SuperAdminMenu permissionContext={permissionContext} loadingPermissions={loadingPermissions} />
		</div>
	);
});

export default Navigation;
